/**
 * The copy a prompt-assist panel shows when its request fails.
 *
 * Both panels show their own fixed wording for a failure — except a **429**, whose message the
 * server writes for the user and which says the one thing the fixed wording cannot: that the fix
 * is to wait, and that it is prompt drafting that is limited, not image generation (gap G1 in
 * WANDERLIGHT-ALIGNMENT.md). "Please try again" would send a rate-limited user straight back into
 * the limit.
 *
 * Deliberately 429 only. Every other failure keeps the panel's copy exactly as before, so this
 * changes one case rather than re-deciding every status.
 */
import { ApiClientError } from "@/api/client";

export function assistFailureMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiClientError && error.status === 429 && error.message) {
    return error.message;
  }
  return fallback;
}
